import { TextField } from "@mui/material";

export const FormTextField = ({
  label,
  name,
  value,
  onChange,
  required = false,
  ...props
}) => (
  <TextField
    label={label}
    name={name}
    variant="outlined"
    fullWidth
    required={required}
    value={value}
    onChange={onChange}
    {...props}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: 2,
        transition: "all 0.3s ease",
        "& fieldset": {
          borderColor: "#BDC3C7",
          borderWidth: "1px",
        },
        "&:hover fieldset": {
          borderColor: "#2980b9",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1f3a5a",
          borderWidth: "2px",
        },
        "& input": {
          padding: "12px 14px",
          fontSize: "1rem",
        },
        "& textarea": {
          padding: "12px 14px",
        },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1rem",
        color: "#34495e",
        transition: "color 0.3s ease",
      },
      "& .MuiInputLabel-root.Mui-focused": {
        color: "#1f3a5a",
      },
      "& .MuiInputBase-input::placeholder": {
        color: "#95a5a6",
        opacity: 1,
        fontStyle: "italic",
      },
    }}
  />
);
